import { useEffect, useState } from 'react';

/** A phone held upright: narrower than 640px. Laptop and iPad widths are on the other side of it. */
export const NARROW_QUERY = '(max-width: 639px)';

/**
 * True on a phone held upright, where tables become one card per row (owner-approved polish,
 * 25 Oct 2026: laptop and iPad keep today's layout). Read from matchMedia rather than CSS so only
 * ONE of the two layouts is in the page; without matchMedia (a test, an old browser) it is false,
 * the wide layout. The year-by-year window has its own copy of this (ProjectionsModal.tsx).
 */
export function useNarrowScreen(): boolean {
    const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
    const [narrow, setNarrow] = useState(() => (supported ? window.matchMedia(NARROW_QUERY).matches : false));
    useEffect(() => {
        if (!supported) return undefined;
        const mq = window.matchMedia(NARROW_QUERY);
        const onChange = () => setNarrow(mq.matches);
        mq.addEventListener?.('change', onChange);
        return () => mq.removeEventListener?.('change', onChange);
    }, [supported]);
    return narrow;
}
